/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SandboxRuntimeProfile = {
  Standard: "standard",
  EvalPython: "eval-python",
} as const;
export type SandboxRuntimeProfile = ClosedEnum<typeof SandboxRuntimeProfile>;

/** @internal */
export const SandboxRuntimeProfile$inboundSchema: z.ZodNativeEnum<
  typeof SandboxRuntimeProfile
> = z.nativeEnum(SandboxRuntimeProfile);
/** @internal */
export const SandboxRuntimeProfile$outboundSchema: z.ZodNativeEnum<
  typeof SandboxRuntimeProfile
> = SandboxRuntimeProfile$inboundSchema;
